export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "Adres serwera": "Serveradresse",
        "Baza danych tego klienta jest nieaktualna.": "Die Datenbank dieses Kunden ist nicht aktuell.",
        "Bazy danych": "Datenbanken",
        "Data dodania": "Hinzugefügt am",
        "Dodaj klienta": "Kunden hinzufügen",
        "Dodaj serwer": "Server hinzufügen",
        "Dodanie klienta": "Hinzufügen eines Kunden",
        "Dodanie serwera": "Hinzufügen eines Servers",
        "Dodawanie klienta SaaS": "SaaS-Kunden hinzufügen",
        "Dodawanie serwera bazy danych": "Datenbankserver hinzufügen",
        "Dodawanie serwera plików": "Dateiserver hinzufügen",
        "Edycja klienta": "Kunden bearbeiten",
        "Edycja klienta SaaS": "SaaS-Kunden bearbeiten",
        "Edycja serwera": "Server bearbeiten",
        "Edycja serwera bazy danych": "Datenbankserver bearbeiten",
        "Edycja serwera plików": "Dateiserver bearbeiten",
        "Edytuj": "Bearbeiten",
        "Hasło": "Passwort",
        "Hasło (Klucz ukryty)": "Passwort (Schlüssel verborgen)",
        "Hasło użytkownika serwisowego": "Passwort des Dienstbenutzers",
        "Host dodatkowy": "Zusätzlicher Host",
        "Host główny": "Primärer Host",
        "Katalog": "Verzeichnis",
        "Klienci": "Kunden",
        "Klient aktywny": "Kunde aktiv",
        "Klient został dodany.": "Der Kunde wurde hinzugefügt.",
        "Klient został usunięty.": "Der Kunde wurde gelöscht.",
        "Klient został zaktualizowany.": "Der Kunde wurde aktualisiert.",
        "Kontener plików": "Dateicontainer",
        "Migracje": "Migrationen",
        "Nazwa bazy danych": "Datenbankname",
        "Nazwa klienta": "Kundenname",
        "Nazwa konta (Klucz dostępu)": "Kontoname (Zugriffsschlüssel)",
        "Nazwa serwera": "Servername",
        "Nazwa użytkownika": "Benutzername",
        "Nazwa użytkownika serwisowego": "Benutzername des Dienstbenutzers",
        "Nie udało się pobrać listy serwerów baz danych": "Die Liste der Datenbankserver konnte nicht abgerufen werden",
        "Nie udało się pobrać listy serwerów plików": "Die Liste der Dateiserver konnte nicht abgerufen werden",
        "Nie udało się wczytać listy. Spróbuj ponownie.": "Die Liste konnte nicht geladen werden. Versuchen Sie es erneut.",
        "Port": "Port",
        "Port serwera": "Serverport",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Region": "Region",
        "Serwer bazy danych": "Datenbankserver",
        "Serwer dostępny": "Server verfügbar",
        "Serwer plików": "Dateiserver",
        "Serwer został dodany.": "Der Server wurde hinzugefügt.",
        "Serwer został usunięty.": "Der Server wurde gelöscht.",
        "Serwer został zaktualizowany.": "Der Server wurde aktualisiert.",
        "Serwery plików": "Dateiserver",
        "Spróbuj ponownie": "Erneut versuchen",
        "Symbol klienta": "Kundenkürzel",
        "System": "System",
        "Tryb konserwacji systemu": "Systemwartungsmodus",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Nur für Entwicklungsserver. Nicht im Produktionsmodus verwenden. ",
        "Typ serwera": "Servertyp",
        "Usługi": "Dienste",
        "Ustawienia zaawansowane": "Erweiterte Einstellungen",
        "Usuń": "Löschen",
        "Wczytywanie danych…": "Daten werden geladen…",
        "Wybierz serwer": "Server auswählen",
        "Zapisz": "Speichern",
        "Zapisz i wróć": "Speichern und zurück"
    }
};
